import { MessageCentreThreadStoreStateType } from '../../Types/MessageCentreThreadStoreTypes';

export const defaultMessageCentreThreadData: MessageCentreThreadStoreStateType = {
	composerOpen: false,
	composerSendDisabled: true,
	groupedMessageData: {},
	messageContent: '',
	messageAttachments: null,
	attachmentsManagerOpen: false,
	attachmentCountError: false,
	attachmentSizeError: false,
	attachmentSize: 0,
};
